export default {
  home: {
    minute: '分钟',
    price_info: '首{mianfei}分钟内免费, 日封顶{currencyName}{fengding}, 计费满{currencyName}{yajin}自动扣取押金。',
    feature_1: '四种充电方式，适配所有手机',
    feature_2: '全国通借通还',
    feature_3: '特别为无线充电设计',
    tips_1: '退还充电宝后，您的{currencyName}{yajin}押金将退还给您。',
    yajin_info: '每日最高收费{currencyName}{fengding}',
    tips_2: '充值押金{currencyName}{yajin}即可租用，用完即可退',
    tips_3: '当前余额{currencyName}{myyue}，可以直接租借',
    submit: '立即充值',
    borrow: '立即租借',
    msg_fail_title: '提示',
    msg_fail_content: '租借失败，请重新尝试',
    msg_rentcount: '你当前有{zujieNum}个订单未结束',
    goborrow: '去租借!!!',
    nearby: '查看附近网点',
    preauth: '预授权金额',
    shopTime: '营业时间',
    分钟: '分钟',
    小时: '小时',
    天: '天',
    deviceNo: '设备编号',
    DeviceState: '设备状态',
    Login_Register: '登录/注册',
    add_Devices: '添加设备',
    switching_Devices: '切换设备',
    how_to_use_bajiewifi: '如何使用八借Wifi',
    online_offline: '打开相机，扫描设备背面的二维码',
    scan_device_code: '注册并登录',
    pay_for_the_order: '绑定设备序列号',
    behind_the_device: '选择目的地国家、选择流量套餐、支付订单',
    num5: '长按开关键5-6秒打开mifi，等待1分钟左右',
    num6: '手机连接设备WiFi',
    refueling_pack: '购买加油包',
    used: '已使用',
    remaining: '剩余',
    start_time: '开始时间',
    end_time: '结束时间',
    purchase_of_traffic: '购买流量',
    purchased_packages: '已购买的套餐',
    add_equipment: '添加设备',
    device_management: '设备管理',
    faq: 'FAQ',
    complaint_suggestions: '投诉建议',
    data_has_been_used_up: '数据已经用完了。你想买一个加油包吗？',
    original_traffic: '当原始流量用完或到期时，此加油包将自动生效',
    Buy1: '购买',
    Unbound: '--',
    Bind: '绑定',
    Confirm: '确定',
    Scan_QR_code: '扫描二维码',
    ScanDevice: '扫描设备背面的二维码',
    无限流量: '无限流量',
    WiFi_Name: 'WiFi名称',
    WiFi_Password: 'WiFi密码',
    offline: '网络未连接',
    online: '网络已连接',
    Package_Information: '套餐信息',
    Purchase_history: '历史套餐',
    Popular_countries_and_regions: '选择国家和地区购买套餐',
    Popular_Packages: '流量包',
    Device_SN: '设备号',
    Network_Status: '网络状态',
    Indicator_Light_Description: '指示灯',
    Contact_Us: '联系我们',
    More_countries_and_regions: '更多国家和地区',
    Log_In: '登录',
    logout: '退出',
    comfirm: '确认',
    cancel: '取消',
    logoutMsg: '是否退出登录?',
    ScanQrBtn: '扫描二维码',
    sendEmail: '发送邮件',
    sendWhatApp: 'WHATSAPP',
    scanMsg: '未知二维码'
  },
  button: {
    添加新卡: '添加新卡',
    Delete: '删除'
  },
  selectpackage: {
    powerbank: '充电宝',
    powerstation: '储能电池',
    wifibox: 'wifi 宝',
    choosepackage: '选择流量包',
    minute: '分钟',
    首次免费: '首次免费',
    最大每日收费: '最大每日收费',
    devicedeposit: '设备押金',
    return_will_back: '归还设备后退还押金',
    lengthofuse: '使用时长',
    amountcharged: '累计收费金额'
  },
  wifimall: {
    Select: '选择',
    subtitle: '推荐的流量包',
    dayuse: '使用天数',
    Verify: '验证',
    无限流量: '无限流量',
    天: '天',
    days: '天',
    useDay: '使用天数',
    mypackages: '已有套餐取机',
    没有更多了: '没有更多了',
    加载中: '加载中',
    depositof: '包含押金 ',
    usagetime: '使用时间',
    Start_time: '开始时间',
    End_time: '结束时间',
    used: '已使用',
    Remaining: '流量',
    Wifi_Name: 'Wifi名称',
    Password: '密码',
    Back_to_home: '返回首页'
  },
  paymethod: {
    payamount: '支付金额',
    choosepaymethod: '选择支付方式',
    addcard: '添加卡',
    confrimpay: '确认支付',
    借记卡: '借记卡',
    银行卡列表: '银行卡列表'
  },
  login: {
    title: '登录',
    code_title: '短信验证',
    phone_number: '手机号码',
    verification_code: '请输入短信验证码，如果没有验证码，请尝试其他登录方法',
    captcha_code: '验证码',
    send_code: '获取验证码',
    login: '登录',
    continue: '继续',
    agree: '点击登录，表示已阅读并同意',
    readme: '使用条款',
    msg_fail_login: '登录失败',
    msg_success_login: '登录成功',
    msg_fail_user: '获取用户信息出错，是否重试？',
    sign_in_with: '第三方登录',
    no_sms: '没收到短信',
    retry: '重新发送',
    applelogin: '使用苹果登录',
    otherlogin: '其他登录方式',
    quicklogin: '快速登录',
    mobilelogin: '手机号',
    emaillogin: '邮箱',
    facelogin: '使用Facebook登录',
    Verification_Code: '验证码',
    Code_is_sent_to: '验证码发送到',
    resend: '收不到验收吗? ',
    rsendIn: '重新发送 '
  },
  confirm: {
    'Credit Card': 'Credit Card',
    WeChat: 'WeChat',
    'Apple Pay': 'Apple Pay',
    'Google Pay': 'Google Pay',
    'SMS Payment': 'SMS Payment',
    'Idael Pay': 'Idael Pay',
    title: '确认付款',
    savenow: '立即保存',
    confirmpay: '立即付款',
    SMSConfirm: '请根据手机收到的短信提示付款后点击确认按钮继续。',
    pay_label: '需支付',
    auth_label: '预授权',
    price_tips: '充值金额申请提现后1~5天到账',
    // auth_tips: '预授权金额{currencyName}{yajin},归还后按实际租金扣取',
    auth_tips: '预授权金额{0}{1},归还后按实际租金扣取',
    pay_type: '请选择支付方式',
    submit: '确认支付',
    msg_loading: '加载中...',
    msg_fail_title: '提示',
    msg_fail_payment: '发起押金支付失败',
    msg_fail_order: '创建租借订单失败',
    msg_fail_support: '当前环境不支持',
    msg_fail_confirm: '确定',
    msg_fail_retry: '重试',
    msg_fail_cancel: '取消',
    msg_none_msg: '请输入其他便于识别您的信息',
    available_packages: '可用流量',
    want_login: '您想现在登录吗？',
    enjoy_more_services: '登录后，您可以享受更多服务，如查看购买记录等。',
    login: '登录',
    continue_buy: '继续购买',
    already_in_effect: '已经生效',
    not_effective: '未生效',
    天: '天',
    days: '天'
  },
  mine: {
    title: '个人中心',
    wallet: '我的钱包',
    balance: '我的余额',
    deposit: '押金',
    wallet_in: '充值',
    wallet_out: '提现',
    wallet_log: '充值提现',
    order: '租借订单',
    coupon: '优惠券',
    login_tips: '请先登录',
    msg_fail_title: '提示',
    msg_fail_update: '修改失败，请重新尝试',
    msg_loading: '加载中...',
    msg_fail_user: '获取用户信息出错，是否重试？',
    help: '帮助',
    setting: '设置',
    logout: '退出',
    buy: '购买设备',
    aboutus: '关于我们',
    contactus: '联系我们',
    security: '安全设置'
  },
  msg: {
    no_phone: '手机号必填',
    loading: '加载中...',
    title: '提示',
    success: '操作成功',
    error: '未知异常，请联系管理员',
    deletecard: '确认删除该卡吗？',
    confirm: '确认',
    retry: '重试',
    cancel: '取消',
    title_fail: '错误',
    vieworder: '查看订单',
    success_payment: '充值成功',
    success_buy: '购买成功',
    fail_payment: '付款失败',
    keyword: '关键词',
    nodata: '未找到数据',
    copysuccess: '复制成功',
    notopen: '暂未开放',
    devicenotactivated: '设备未激活',
    pickup_fail: '取机失败，请稍后重试',
    msg_none_name: '请输入您的名字',
    msg_none_email: '请输入您的邮箱',
    msg_none_mobile: '请输入您的手机号',
    msg_none_nation: '请输入您的国家',
    msg_none_msg: '请输入其他方便辨识您身份的信息',
    msg_fail_choosepackage: '请选择一个套餐取机',
    geolocationfailed: '错误：地理定位服务失败。'
  },
  result: {
    title: '确认结果',
    price_plan: '计费规则',
    msg_success: '租借成功',
    msg_tips_loading: '正在弹出充电宝，请耐心等待...',
    msg_result_loading: '正在确认支付结果...',
    msg_fail_confirm: '确定',
    btn_usage: '使用说明',
    btn_return: '归还说明',
    deposit: '押金',
    msg_fail_content: '请求失败，请重新尝试',
    price_label: '/小时',
    price_info: '{mianfei}分钟内免费，日封顶{fengding}{ccurrency}，计费满{yajin}{ccurrency}自动扣取押金',
    tips_1: '请按图取走<span class="number">{number}号</span>位置充电宝',
    tips_2: '归还请收好按箭头<span class="highlight">【线朝下方】</span>插入机柜并锁',
    msg_note_usage: '充电宝配有三种充电线，请按需使用',
    msg_note_return: '请把充电线插回相应位置后，把充电宝插入机柜的卡槽中',
    return_info: '归还时，整理好充电线，将充电宝芯片端插入机柜空缺槽口至底部被固定即可。'
  },
  result_msg: {
    loading: '加载中...',
    refresh: '点击刷新'
  },
  order: {
    title: '租借订单',
    in_use: '正在使用',
    ended: '已结束',
    enter_order_email: "请输入邮箱",
    msg_error: '加载失败'
  },
  order_item: {
    order_number: '订单号',
    venue_rented: '租借地点',
    time_rented: '租借时间',
    venue_returned: '归还地点',
    time_returned: '归还时间',
    charge_standard: '收费标准',
    charge_standard_info: '每小时{pJifei}{pCurrency}(前{pMian}分钟免费)',
    rent_occurred: '租借费用',
    returned: '已归还',
    unreturned: '未归还',
    type_0: '未租借',
    type_1: '租借中',
    type_2: '已撤销',
    type_3: '已归还',
    type_4: '有疑问',
    type_5: '超时归还',
    min: '分',
    payment: '付款'
  },
  setting: {
    title: '设置',
    lang: '选择语言'
  },
  help: {
    title: '帮助',
    reason: '原因:',
    solution: '解决方案:',
    Lights: '轮流闪烁',
    rt0: '可以正常连接网络',
    rt1: '1.已购买套餐系统尚未分配网络',
    rt2: '2.未购买套餐',
    rt3: '3.套餐未到生效时间/地区',
    st1: '1.重启设备并等待5分钟',
    st2: '2.检查是否已购买套餐',
    st3: '3.生效时间/地区',
    t1: '已购买套餐但是所处位置没有信号基站',
    t2: '自行移动至其他地方搜索网络',
    t4: '未购买套餐且所处位置没有信号基站',
    t5: '自行移动至其他地方搜索网络',
    t6: '未打开MIFI功能',
    t7: '请长按设备电源键7-9S直到三个灯开始轮流闪烁',
    key1: "为什么充值了还是用不了网络？",
    value1: "如果在生效时间内，可能是系统正在分配网络，需要重启设备并等待5分钟",
    key2: '如何重启设备？',
    value2: '双击电源键关闭设备，然后长按电源键7-10秒启动设备',
    key3: '我该如何为MIFI充电？',
    value3_1: '1.拔出中间那条Type-A数据线，插入usb接口',
    value3_2: '2.使用Type-C数据线插入设备侧边的插口进行充电',
    key4: '我购买美国套餐可以在墨西哥使用吗？',
    value4: '不可以，购买美国套餐只能在美国使用。需要在哪个国家使用网络就购买哪个国家的套餐',
    key5: '怎么购买流量？',
    value5: '点击流量商城，选择你要购买的国家套餐，付款',
    key6: '如何快速获得技术支持？',
    value6: '请点击“联系我们”按钮，通过发送邮件或者WHATS APP直接在线与我们聊天',
    key7: '如何关闭设备？',
    value7: '双击电源键',
    key8: '这个设备可以作为充电宝使用吗？',
    value8: '当然可以，只要按一下电源键就可以打开充电宝功能，为其它设备充电。',
    key9: '我能连接几台设备？',
    value9: '5台设备以内，可以保证你的网速不会下降，超过5台设备网速可能会下降',
    key10: '为什么我数据没用完却不能继续用了',
    value10: '请检查是否已超过使用时间或者是否在套餐生效地区',
    key11: '我需要每个月都交钱吗?',
    value11: '我们是预付款模式，套餐结束就不会再扣费。如果还需要使用网络，需要再次充值。',
    ps: 'ps:如遇到无法解决的问题，请及时联系工作人员处理'
  },
  wallet_in: {
    title: '余额充值',
    price_label: '充值金额',
    price_placeholder: '请输入充值金额',
    balance: '当前余额',
    price_auto: '自动充值',
    price_tips: '充值金额申请提现后1~5天到账',
    submit: '确定充值',
    loading: '加载中...',
    paying: '跳转到付款页...',
    msg_title: '提示',
    msg_fail_order: '创建充值订单失败',
    msg_fail_payment: '发起充值支付失败',
    msg_fail_retry: '重试',
    选择充值金额: '选择充值金额',
    输入充值金额: '输入充值金额',
    确认充值: '确认充值'
  },
  wallet_out: {
    title: '余额提现',
    price_label: '提现金额',
    price_placeholder: '请输入提现金额',
    balance: '当前余额',
    balance_all: '全部提取',
    deposit: '押金',
    deposit_tips: '目前有租借中的订单，押金{pcurrencyName}{pyajin}暂不可退',
    submit: '立即提现',
    apply: '申请提现',
    confirm: '确认',
    loading: '加载中...',
    msg_fail_price: '提现金额不正确',
    msg_fail_balance: '提现金额不能大于当前余额',
    msg_fail_submit: '请填写完整信息',
    msg_title: '错误',
    msg_success_content: '申请提现成功',
    confirmtitle: '提示',
    confirmcontent: '当前钱包不支持提现，请备注您的联系方式后由人工退款',
    payee_name: '姓名',
    payee_bankcard: '银行卡号',
    payee_phone: '电话',
    cancelText: '取消',
    confirmText: '再次申请',
    退款金额: '退款金额'
  },
  map: {
    title: '附近设备',
    result_msg: '附近未找到相关设备',
    msg_title: '错误',
    no_support: '抱歉！您的浏览器不支持定位',
    my_position: '我的位置',
    distance: '距你',
    shop_time: '营业时间',
    free: '可借',
    return: '可还',
    shop_title: '商家详情',
    address: '地址',
    go_here: '去这里'
  },
  scanOrder: {
    title: '订单详情',
    viewflowdetail: '查看流量使用详情',
    confirmpickup: '确认取机',
    QRpickup: '二维码取机',
    取机中: '取机中',
    scanQR: '扫码取机',
    qrCodePickup: '二维码取机',
    orderNo: '订单编号',
    orderTime: '订单时间',
    orderId: '订单id',
    startingTime: '开始时间',
    endTime: '结束时间',
    packageStatus: '订单状态',
    无限流量: '无限流量',
    天: '天',
    days: '天',
    type_0: '未使用',
    type_1: '待激活',
    type_2: '已激活',
    type_3: '已撤销',
    type_4: '已退款',
    type_9: '已结束',
    type_33: '未支付',
    type_88: '已取消',
    inputserialNumber: '请输入设备的sn',
    pickupsuccess: '取机成功',
    continuepay: '继续支付',
    payMethods: '支付方式',
    Purchased: '流量包',
    Use_completed: '使用完成',
    ready_to_use: '未使用',
    Buy_Again: '再次购买',
    Back_to_home: '返回首页',
    inuse: '使用中',
    Cancelled: '取消'
  },
  borrowSuccess: {
    title: '成功',
    success: 'success',
    renewalTraffic: '续购套餐',
    viewOrder: '查看订单',
    HowUseDevice: '如何使用设备',
    oneMoreOrder: '更多订单',
    Back_to_home: '返回首页',
    the: '此',
    package: '套餐将于',
    effective: '生效',
    天: '天'
  },
  packageOrder: {
    title: '购买套餐',
    viewdetail: '详情',
    buynow: '立即购买',
    isrent: 'Is the equipment rented?',
    timelimited: 'Time-limited offer',
    Days_of_use: '每天使用',
    Usage_time: '使用时间',
    End_time: '结束时间',
    Note: '备注',
    used_per_day: '数据流量可以使用',
    Code: '验证码',
    Verification_Code: '验证码',
    Buy_Now: '立即购买',
    ddd: '您购买的套餐将在设备序列号上生效',
    ccc: '请检查您需要充电的设备是否正确',
    device_number: '查看设备背面的设备编号或扫描二维码',
    Continue_purchasing: '继续购买',
    天: '天',
    无限流量: '无限流量',
    Instructions: '介绍',
    t1: '使用区域：仅适用于购买国家/地区。',
    t2: '流量生效后，系统将在5分钟内激活。请耐心等待设备上线。如果仍然没有网络，请重新启动设备。',
    t3: '实际网络速度受到信号和服务提供商质量等因素的影响。'
  },
  packageDetail: {
    WiFiName: 'WiFi 名称',
    WiFiPassword: 'WiFi 密码',
    batteryLife: '电量',
    Signal: '信号',
    orderNo: '订单编号',
    startingTime: '开始时间',
    endTime: '结束时间',
    packageStatus: '订单状态',
    usedTraffic: '已用流量',
    Renewals: '续购',
    inuse: '使用中'
  },
  orderDetail: {
    payment: '去支付',
    orderNo: '订单编号',
    trafficDetails: '查看流量详情',
    Renewals: '续购',
    FeeSchedule: '费用表',
    HowToUse: '如何使用',
    LeaseMerchant: '租赁商户',
    startTime: '开始时间',
    ReturningMerchants: '归还商家',
    EndTime: '结束时间',
    Deposit: '租金',
    fee1: '设备押金 $500',
    fee2: '在租赁到期日后 7 天内退还，减去 10 美元/天/单位。',
    fee3: '如果在租赁期满后7天内归还设备，将扣除$200/台。',
    fee4: '如果在租赁天数到期后超过15天仍未归还设备，押金将自动扣除。',
    rentagain: '再次租借'
  },
  pickUp: {
    orderNo: '订单编号',
    startingTime: '开始时间',
    endTime: '结束时间',
    packageStatus: '订单状态',
    confirmationOfPickup: '确认取机'
  },
  aboutus: {
    title: '关于我们',
    desc1: '充电宝是深圳八借充电科技公司旗下的充电宝共享解决方案品牌。深圳市八借充电科技有限公司自2018年成立以来，一直专注于共享经济领域智能终端设备的研发和运营。通过不断的技术创新和应用拓展，我们开发了共享充电宝、共享智能储物柜、共享全球WiFi、共享便携式储能等多种智能终端设备，以满足不同用户和不同场景需求。我们以创新引领市场，通过深入理解和满足用户需求，将共享经济商业模式推广到世界各地。',
    desc2: '八借充电为我们的商业伙伴开发了一个成熟的OEM合作模式。我们可以为您提供我们的设备和技术支持，您可以运营自己的充电宝共享服务品牌。',
    contactustitle: '有兴趣成为Chargenow的合作伙伴吗？请联系我们——',
    formtitle: '有问题吗？联系我们！',
    submit: '提交',
    name: '名字',
    email: '邮箱',
    tel: '手机号',
    nation: '国家',
    message: '其他想说的'
  },
  contactus: {
    title: '联系我们',
    desc1: '充电宝是深圳八借充电科技有限公司旗下的充电宝共享解决方案品牌。Chargenow运营着一项充电宝共享服务，特许经营商遍布世界各地。',
    desc2: '如果您有兴趣加入我们的特许经营业务，请联系我们在中国的总部。',
    contactustitle: '中国总部',
    contactussubtitle: '中国广东省深圳市宝安区福永镇建安路25号金星工业园区3号楼7层。',
    contactusinfotitle: '对于在租用共享电源时遇到问题的最终用户，请联系您当地的特许经营商。以下是他们各自的联系信息和地址：',
    method1: '格兰索尔巴西',
    methoddesc1: 'Av. Ana Costa, 61 EV 506 Santos/SP CEP 11060-001',
    method2: '哈萨克斯坦地区',
    methoddesc2: '阿克套市'
  },
  activation: {
    activation: 'Activation',
    welcome: '欢迎',
    thank: '感谢您购买Pocket Wi-Fi',
    hello: '你好',
    device_sn: '设备号',
    viewing_methods: '查看方式',
    mail: '邮箱',
    code: 'Code',
    verification_code: '验证码',
    send: '发送',
    binding: '绑定',
    back_to_home: '返回首页',
    scan_the_qr_code: '查看设备背面的设备编号或扫描二维码'
  },
  deviceManager: {
    devices_management: '设备管理',
    default_devive: '默认设备',
    devices: '设备',
    delete: '删除',
    bind_multiple: '可以绑定多个设备',
    add_a_device: '添加一个设备',
    back_to_home: '返回首页',
    do_you_delete: '是否要删除这个设备?',
    set_as_default: '默认'
  },
  purchasedPackages: {
    purchased_packages: '加油包',
    to_be_paid: '未支付',
    cancel_order: '取消订单',
    go_to_payment: '付款',
    Cancelled: '取消',
    Reordering: '查看记录',
    use_completed: '使用完成',
    purchased: '流量包 (使用中)',
    purchased10: '未开始',
    all: '全部',
    Purchased: '已购买',
    Completed: '完成'
  }
}
